import { useEffect, useState } from 'react';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { EXTERNAL_CLIENTS_GROUP_REF } from '../externalUsers/types';

export function useIsExternalClient() {
  const identityApi = useApi(identityApiRef);
  const [loading, setLoading] = useState(true);
  const [isExternalClient, setIsExternalClient] = useState(false);

  useEffect(() => {
    let mounted = true;
    void (async () => {
      try {
        const identity = await identityApi.getBackstageIdentity();
        const refs = (identity.ownershipEntityRefs ?? []).map(ref =>
          ref.trim().toLowerCase(),
        );
        if (mounted) {
          setIsExternalClient(refs.includes(EXTERNAL_CLIENTS_GROUP_REF));
        }
      } catch {
        if (mounted) {
          setIsExternalClient(false);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    })();
    return () => {
      mounted = false;
    };
  }, [identityApi]);

  return { isExternalClient, loading };
}
